import Vue from 'vue';
import Vuex from 'vuex';
import {authRef, dbRef, dbCtgs, gProvider } from './db.js';

Vue.use(Vuex); // vuex 사용

export const store = new Vuex.Store({ // store export
    state: {
        temp: [], 
        todoItems: [],
        categories:[],
        userAuth: {
            status: false,
            email:"",
            name:"",
        }
    },
    getters: {
        getTodos: state => {            
            return state.todoItems;
        },
        getAuth: state => {
            return state.userAuth;
        },
        getCtgs: state => {
          return state.categories;
        },
        getEmail: state => {
          return state.userAuth.email;
        }
    },
    mutations: {
        addTodo: (state, value) => {
            state.todoItems.push(value);
        },
        clearAll: state => {
            state.todoItems = [];
        },
        userAuth: (state, value) => {
            state.userAuth.status = true;
            state.userAuth.email = value.email;
            state.userAuth.name = value.displayName;
        },
        logOut: state => {
          state.userAuth.status = false;
          state.userAuth.email = "";
          state.userAuth.name = "";
        },
        clearCtgs: state => {
            state.categories = [];
        },
        addCtgs: (state, value) => {
            state.categories.push(value);
        }
    },
    actions: {
        clearAll: (context, time) => { // 비동기 작업 수행 후 mutation commit
            setTimeout(() => context.commit('clearAll'), time)
        },
        getTodos: (context) => {
            dbRef.onSnapshot(query => {
                context.commit('clearAll');
                query.forEach(doc => {
                    const todo = {
                      'user': doc.data().user,
                      'id': doc.id,
                      'ctg': doc.data().ctg,
                      'title': doc.data().title,
                      'content': doc.data().content,
                      'deadline': doc.data().deadline,
                      'status': doc.data().status,
                      'remove': doc.data().remove
                    }
                    context.commit('addTodo', todo);
                    
                });
            });
        },
        getCtgs: (context) => {
            dbCtgs.onSnapshot(query => {
                context.commit('clearCtgs');
                query.forEach(doc => {
                    context.commit('addCtgs', {
                        'value': doc.data().category,
                        'text': doc.data().category,
                        'user': doc.data().user
                    });
                });
            });
        },
        removeTodo: (context, payload) => {
          dbRef.doc(payload).delete();
        },
        removeCtg: (context, payload) => {
            dbCtgs.doc(payload).delete();
        },
        BinTodo: (context, payload) => {
          dbRef.doc(payload).update({
            remove: true
          })
        },
        RestoreTodo: (context, payload) => {
          dbRef.doc(payload).update({
            remove: false
          })
        },
        DeleteComplete: (context) => {
          dbRef.onSnapshot(query => {
              query.forEach(doc => {
                  const todo = {
                    'user': doc.data().user,
                    'id': doc.id,
                    'remove': doc.data().remove
                  }
                  if(todo.user == context.state.userAuth.email && todo.remove == true){
                    dbRef.doc(todo.id).delete();
                  }
              });
          });
        },
        DoneTodo: (context, payload) => {
          dbRef.doc(payload.id).update({
            status: !payload.status
          })
        },
        addTodo: (context, value) => {
            let id = Date.now().toString();
            dbRef.doc(id).set({
              'id': Date.now().toString(),
              'user': context.state.userAuth.email,
              'ctg': value.ctg,
              'title': value.title,
              'content': value.content,
              'deadline': value.deadline,
              'status': false,
              'remove': false
            });
        },
        addCtg: (context, value) => {
            let id = value; 
            dbCtgs.doc(id).set({
                'user': context.state.userAuth.email,
                'category': value
            }); 
        }, 
        userAuth: (context) =>{
            authRef.signInWithPopup(gProvider)
            .then(result=>{
                context.commit('userAuth', result.user);
            })
        },
        logOut: (context) =>{
          authRef.signOut().then(function() {
            context.commit('userAuth');
          })
        }
    }
});



// WEBPACK FOOTER //
// ./src/store/store.js